import { Component, inject, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslocoModule } from '@jsverse/transloco';
import { SelectButtonModule } from 'primeng/selectbutton';
import { StatsCardComponent } from '../stats-card/stats-card.component';
import { TravelBoardService } from '../../services/travel-board.service';
import { FormatCO2ePipe } from '../../../pipes/format-co2e.pipe';

@Component({
  selector: 'app-board-overview-section',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    TranslocoModule,
    SelectButtonModule,
    StatsCardComponent,
    FormatCO2ePipe,
  ],
  templateUrl: './board-overview-section.component.html',
})
export class BoardOverviewSectionComponent {
  private travelBoardService = inject(TravelBoardService);

  selectedYear: number = 0;

  private yearList = computed(() => {
    const yearList = new Set<number>();
    for (const trip of this.travelBoardService.data()) {
      if (trip.createdAt) {
        yearList.add(new Date(trip.createdAt).getFullYear());
      }
    }
    return [...yearList].sort((a, b) => b - a);
  });

  years = computed(() => {
    const trips = this.travelBoardService.data();
    const options = this.yearList().map((year) => ({
      value: year,
      label: `${year}`,
      count: trips.filter(
        (trip) =>
          trip.createdAt &&
          new Date(trip.createdAt).getFullYear() === year &&
          !trip.isDraft,
      ).length,
    }));

    return [
      {
        value: 0,
        label: '',
        count: trips.filter((trip) => !trip.isDraft).length,
      },
      ...options,
    ];
  });

  get stats() {
    let trips = this.travelBoardService.data();

    if (this.selectedYear && this.selectedYear !== 0) {
      trips = trips.filter((trip) => {
        if (!trip.createdAt) return false;
        const tripYear = new Date(trip.createdAt).getFullYear();
        return tripYear === this.selectedYear;
      });
    }

    // Exclure les drafts pour être cohérent avec le graphique
    const nonDraftTrips = trips.filter((trip) => !trip.isDraft);

    const totalEmissions = nonDraftTrips.reduce(
      (sum, t) => sum + (t.totalImpact || 0),
      0,
    );
    const totalTravelers = nonDraftTrips.reduce(
      (sum, t) => sum + (t.travellers || 0),
      0,
    );

    return {
      totalTrips: nonDraftTrips.length,
      totalEmissions,
      totalTravelers,
      avgImpactPerTraveller:
        totalTravelers > 0 ? totalEmissions / totalTravelers : 0,
    };
  }
}
